export const formFields = {
    password: 'password',
    confirmPassword: 'confirmPassword',
  }
  